/**
 * This function removes specific color codes that comes from tiny's weird conversion
 * of classes (.userchoice and .userinput) to color codes, that end up in the final PDF
 * @param content
 */
export default function sanitizeContent(content: string): string {
  let tmpContent = content;
  if (!tmpContent) return '';
  tmpContent = tmpContent.replace(/#f9f900/gi, ''); // .userinput
  tmpContent = tmpContent.replace(/#05fb05/gi, ''); // .userchoice
  tmpContent = tmpContent.replace(/ style="background-color: ;"/gi, '');
  return tmpContent;
}
